import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Runs callback when the screen becomes active again on web/desktop.
 * Skips the first run after mount because useQuery already loads initial data.
 */
export function useRefetchOnScreenFocus(callback: () => void): void {
  const { key } = useLocation();
  const isFirstCycle = useRef(true);

  useEffect(() => {
    if (isFirstCycle.current) {
      isFirstCycle.current = false;
      return;
    }

    callback();
  }, [key, callback]);
}
